import { useState } from "react";
import { MagnifyingGlass } from "@phosphor-icons/react";
import api, { fileUrl } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { btnGhost, btnPrimary, inp, toastErr } from "./util";

export function ProductImg({ p, className = "w-10 h-10" }) {
    const srcs = [...new Set([p.catalog_image && fileUrl(p.catalog_image), p.thumbnail].filter(Boolean))];
    const [n, setN] = useState(0);
    if (n >= srcs.length) return <div className={`${className} bg-cream border border-mist shrink-0 grid place-items-center text-[8px] uppercase text-neutral-400 text-center leading-tight`} data-testid="product-img-placeholder">No photo</div>;
    return <img src={srcs[n]} alt="" onError={() => setN(n + 1)} className={`${className} object-cover border border-mist shrink-0`} data-testid="product-img" />;
}

export function ProductLine({ p, testid }) {
    return (
        <div className="flex items-center gap-2 min-w-0" data-testid={testid}>
            <ProductImg key={`${p.catalog_image}|${p.thumbnail}`} p={p} />
            <div className="min-w-0 text-xs">
                <div className="font-medium text-ink truncate">{p.name || "—"}</div>
                <div className="text-neutral-500 break-all">{p.item_code}{p.stock != null && <> · Stock <b data-testid={`${testid}-stock`}>{p.stock}</b></>}</div>
            </div>
        </div>
    );
}

export function JubelioPicker({ open, onClose, onPick, initial = "" }) {
    const [q, setQ] = useState(initial);
    const [rows, setRows] = useState(null);
    const [busy, setBusy] = useState(false);
    const search = async () => {
        if (!q.trim()) return;
        setBusy(true);
        try { setRows((await api.get("/invoices/jubelio/search", { params: { q } })).data); } catch (e) { toastErr(e, "Jubelio search failed"); } finally { setBusy(false); }
    };
    return (
        <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
            <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid="jubelio-picker">
                <DialogHeader><DialogTitle>Find product</DialogTitle></DialogHeader>
                <p className="text-xs text-neutral-500">Includes out-of-stock products.</p>
                <div className="flex gap-2">
                    <input className={inp} value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && search()} placeholder="Product or SKU" data-testid="jubelio-picker-input" />
                    <button type="button" className={btnPrimary} onClick={search} disabled={busy} data-testid="jubelio-picker-search"><MagnifyingGlass size={14} /></button>
                </div>
                {rows && rows.length === 0 && <p className="text-xs text-neutral-400">No product found.</p>}
                <div className="divide-y divide-mist">
                    {(rows || []).map((p) => (
                        <div key={`${p.item_id}-${p.item_code}`} className="py-2 flex items-center justify-between gap-2">
                            <ProductLine p={p} testid={`jubelio-result-${p.item_code}`} />
                            <button type="button" className={btnGhost} onClick={() => { onPick(p); onClose(); }} data-testid={`jubelio-pick-${p.item_code}`}>Select</button>
                        </div>
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    );
}
